import { Holidays, NationalHolidays, UserHolidays } from 'app/Users/models';

function calendarParser(data: NationalHolidays[] | UserHolidays[], toParse: 'national' | 'user'): Holidays[] {
    const holidays: Holidays[] = [];
    for (const holiday of data) {
        if (toParse === 'user') {
            const parse = holiday as UserHolidays;
            holidays.push({
                alias: parse.alias,
                start_time: parse.start_time,
                end_time: parse.end_time,
                foreignhash: parse.foreignhash,
                national_holiday: parse.national_holiday,
                active: parse.active,
                to_all_cameras_user: parse.to_all_cameras_user,
                all_day: parse.all_day,
                hash_holiday: parse.hash_holiday,
                cameras_info: parse.cameras_info
            });
        } else {
            const parse = holiday as NationalHolidays;
            holidays.push({
                alias: parse.name,
                start_time: parse.date_begin,
                end_time: parse.date_end,
                national_holiday: true
            });
        }
    }
    return holidays;
}

export {
    calendarParser
};
